import classNames from 'classnames';
import {
  Button,
  FlexContainer,
  Txt,
  View,
  TenantDepositDetails,
  Modal,
  PaymentFlow,
} from 'components';
import { observer } from 'mobx-react-lite';
import { formatCurrency } from 'helpers/formatNumber';
import { useState } from 'react';
import { useTenancy } from 'state';
import { ModalGlobal } from 'lib/ModalContext';
import styles from './DepositNotLinked.module.scss';

/**
 * DepositNotLinked
 *
 * @return {JSX.Element}
 */
const DepositNotLinked = ({ className, onSuccess }) => {
  const tenancyDoc = useTenancy();
  const [payOrder, setPayOrder] = useState(false);
  const { tenants: tenantsCollection } = tenancyDoc;

  const tenancyData = tenancyDoc.data;
  const tenantsData = tenantsCollection.data;

  const handlePay = () => {
    setPayOrder(true);
    console.log('Payment');
  };

  const handleClose = () => setPayOrder(false);

  return (
    <FlexContainer
      className={classNames(
        styles.DepositNotLinked,
        className,
        DepositNotLinked.displayName
      )}
      gap
      column
    >
      <Txt bold>⚠️ Awaiting tenant payment</Txt>
      <View>
        <Txt xxx bold>
          £{formatCurrency(tenancyData.payments.depositAmountPaid)}
        </Txt>
        <Txt caption>
          /£{formatCurrency(tenancyData.payments.depositAmount)}
        </Txt>
      </View>
      <FlexContainer column gapHalf>
        {tenantsData.map((t) => {
          return (
            <TenantDepositDetails
              key={t.id}
              fullName={t.data.fullName}
              actionLabel={t.data.payments?.depositPlaidUid ? 'PAID' : 'DUE'}
              emailAddress={t.data.emailAddress}
              mobileNumber={t.data.mobileNumber}
              isDone={t.data.payments?.depositPlaidUid}
            />
          );
        })}
      </FlexContainer>
      <Txt regular>
        Your landlord will request a deposit before a tenancy starts, this
        assures them of your commitment to the tenancy.
      </Txt>
      <Txt regular>
        The money is protected in a government authorised tenancy deposit scheme
        for the duration of the tenancy.
      </Txt>
      <Txt regular>
        At the end of the tenancy you will get this money back, unless there is
        damage to the property or arrears on payments of rent or utility bills.
      </Txt>
      <Button success onClick={handlePay}>
        Pay Deposit
      </Button>
      {payOrder ? (
        <ModalGlobal>
          <Modal title="Deposit to pay" onClose={handleClose} showCloseButton>
            <PaymentFlow paymentType="tenantDeposit" onSuccess={onSuccess} />
          </Modal>
        </ModalGlobal>
      ) : null}
    </FlexContainer>
  );
};

DepositNotLinked.displayName = 'DepositNotLinked';

export default observer(DepositNotLinked);
